import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    title: 'Cómo Vender Amigurumis Personalizados y Cobrar Precio Premium',
    description: 'Guía para emprendedoras: aprende a ofrecer mascotas por raza como servicio exclusivo y diferenciarte del resto.',
    image: 'https://cdn.magicpatterns.com/uploads/xeX1WzteNitxvnS5nyFXao/20260225_1949_Image_Generation_remix_01kjbfvz9rfqx9wh28p8h1m735.png',
    tag: 'Para emprendedoras',
    fakePrice: '$14.99'
  }, {
    title: 'Pack Amigos de Kitty',
    description: 'Colección especial de patrones inspirados en los personajes más tiernos. Perfectos para regalar o vender.',
    image: 'https://cdn.magicpatterns.com/uploads/vTiubZGPogNZWQUUX4wQGQ/20260225_1949_Image_Generation_remix_01kjbfve3aebnvs15r2wfb0nht.png',
    tag: 'Patrones extra',
    fakePrice: '$12.99'
  }, {
    title: 'Patrones Gatitos Halloween',
    description: 'Gatitos con temática de Halloween: calabazas, brujitas y fantasmitas. Ideales para temporada.',
    image: 'https://cdn.magicpatterns.com/uploads/pJVUjm8jXJYYabGZR48rRw/20260225_1949_Image_Generation_remix_01kjbftmr7fw28z5cktr40bdea.png',
    tag: 'Edición especial',
    fakePrice: '$9.99'
  }, {
    title: 'Gatitos Cactus',
    description: 'La combinación más adorable: gatitos disfrazados de cactus. Un diseño único que encanta a todos.',
    image: 'https://cdn.magicpatterns.com/uploads/pSK6XVACehszdNjVPCWT4s/20260225_1948_Image_Generation_remix_01kjbfshcsfbztfch36est4249.png',
    tag: 'Edición especial',
    fakePrice: '$9.99'
  }];
  return <section className="py-10 md:py-16 bg-white" data-id="element-15">
      <div className="max-w-5xl mx-auto px-4" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-17">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-cream rounded-full mb-5" data-id="element-18">
            <Gift size={16} className="text-copper" data-id="element-19" />
            <span className="text-sm font-bold text-copper" data-id="element-20">
              Bonos incluidos
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown mb-3" data-id="element-21">
            Y además, te llevas estos regalos
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto" data-id="element-22">
            Bonos exclusivos que complementan tu colección y te dan aún más
            valor.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-23">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="etsy-card etsy-card-hover overflow-hidden" data-id="element-24">
              {/* 16:9 Image */}
              <div className="relative" data-id="element-25">
                <img src={bonus.image} alt={bonus.title} className="w-full aspect-video object-cover" data-id="element-26" />
                <div className="absolute top-3 left-3" data-id="element-27">
                  <span className="text-[10px] font-bold uppercase tracking-wider bg-white/90 backdrop-blur-sm px-2.5 py-1 rounded-full text-copper shadow-sm" data-id="element-28">
                    {bonus.tag}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-5" data-id="element-29">
                <div className="flex justify-between items-start mb-2" data-id="element-30">
                  <h3 className="font-bold text-deep-brown leading-snug flex-1 pr-2" data-id="element-31">
                    {bonus.title}
                  </h3>
                  <div className="flex flex-col items-end" data-id="element-32">
                    <span className="text-xs text-gray-400 line-through" data-id="element-33">
                      {bonus.fakePrice}
                    </span>
                    <span className="text-xs font-bold text-teal bg-teal/10 px-2 py-0.5 rounded-full" data-id="element-34">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-35">
                  {bonus.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-linen rounded-xl p-6 text-center border border-copper/20" data-id="element-36">
          <p className="text-deep-brown font-bold text-lg" data-id="element-37">
            Valor total de los bonos:{' '}
            <span className="line-through text-gray-400" data-id="element-38">$47.96</span>{' '}
            <span className="text-copper" data-id="element-39">→ HOY INCLUIDOS GRATIS</span>
          </p>
        </motion.div>
      </div>
    </section>;
}